import { render, staticRenderFns } from "./campo-radio-group-editavel.vue?vue&type=template&id=bb720254"
import script from "./campo-radio-group-editavel.vue?vue&type=script&lang=js"
export * from "./campo-radio-group-editavel.vue?vue&type=script&lang=js"
import style0 from "./campo-radio-group-editavel.vue?vue&type=style&index=0&id=bb720254&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports